import axios from 'axios'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

const baseState = {
  isFetchingNotifications: false,
  isReadingNotifications: false,
  isDeletingNotifications: false,
  notifications: {
    read_count: 0,
    unread_count: 0,
    total_count: 0,
    resultsPerPage: 0,
    data: []
  }
}

export default function manageNotifications(state = baseState, action){
  switch(action.type){
    case "FETCHING_NOTIFICATIONS":
      return { ...state, isFetchingNotifications: true }
    case "SET_NOTIFICATIONS":
      return {
        ...state,
        isFetchingNotifications: false,
        notifications: action.payload
      }
    case "REDUCE_READ_COUNT":
      const unreadNotificationIndex = state.notifications.data.findIndex(notification => {
        return notification.url === action.payload.url
      })

      const udatedNotificationsWithUnread = [
        ...state.notifications.data.slice(0, unreadNotificationIndex),
        action.payload,
        ...state.notifications.data.slice(unreadNotificationIndex + 1),
      ]

      return {
        ...state,
        notifications: {
          ...state.notifications,
          read_count: state.notifications.read_count - 1,
          unread_count: state.notifications.unread_count + 1,
          data: udatedNotificationsWithUnread,
        }
      }
    case "INCREASE_READ_COUNT":
      const readNotificationIndex = state.notifications.data.findIndex(notification => {
        return notification.url === action.payload.url
      })

      const udatedNotificationsWithRead = [
        ...state.notifications.data.slice(0, readNotificationIndex),
        action.payload,
        ...state.notifications.data.slice(readNotificationIndex + 1),
      ]

      return {
        ...state,
        notifications: {
          ...state.notifications,
          read_count: state.notifications.read_count + 1,
          unread_count: state.notifications.unread_count - 1,
          data: udatedNotificationsWithRead,
        }
      }
    case "READ_ALL_NOTIFICATIONS":
      return {
        ...state,
        notifications: {
          ...state.notifications,
          read_count: state.notifications.read_count + state.notifications.unread_count,
          unread_count: 0,
          data: state.notifications.data.map(notification => {
            notification.is_read = true
            return notification
          })
        }
      }
    case "DELETE_ALL_NOTIFICATIONS":
      let total_count = 0
      let read_count = 0
      let unread_count = 0
      const data = state.notifications.data.filter(notification => {
        if (notification.is_pinned) {
          if (notification.is_read) {
            read_count += 1
          } else {
            unread_count += 1
          }
          total_count += 1
          return true
        } else {
          return false
        }
      })
      return {
        ...state,
        isFetchingNotifications: false,
        notifications: {
          total_count,
          read_count,
          unread_count,
          data
        }
      }
    case "DELETED_NOTIFICATION":
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: state.notifications.data.filter(notification => notification.url !== action.payload)
        }
      }
    case "PIN_NOTIFICATION":
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: state.notifications.data.map(notification => {
            if (notification.url === action.payload) {
              return { ...notification, is_pinned: true }
            } else {
              return notification
            }
          })
        }
      }
    case "UNPIN_NOTIFICATION":
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: state.notifications.data.map(notification => {
            if (notification.url === action.payload) {
              return { ...notification, is_pinned: false }
            } else {
              return notification
            }
          })
        }
      }
    default:
      return state
  }
}

const fetchingNotifications = () => {
  return { type: "FETCHING_NOTIFICATIONS" }
}

const readingAllNotifications = () => {
  return { type: "READ_ALL_NOTIFICATIONS" }
}

const deletingAllNotifications = () => {
  return { type: "DELETE_ALL_NOTIFICATIONS" }
}

const deletedNotification = (url) => {
  return { type: "DELETED_NOTIFICATION", payload: url }
}

const pinnedNotification = (url) => {
  return { type: "PIN_NOTIFICATION", payload: url }
}

const unpinnedNotification = (url) => {
  return { type: "UNPIN_NOTIFICATION", payload: url }
}

export const setNotifications = (data) => {
  return { type: "SET_NOTIFICATIONS", payload: data }
}

export const updateReadCount = (notification) => {

  if (notification.is_read) {
    return { type: "INCREASE_READ_COUNT", payload: notification }
  } else {
    return { type: "REDUCE_READ_COUNT", payload: notification }
  }
}

export const getNotifications = (userId, page = 1, skipSpinner = false) => {
  if (!userId) {
    return
  }

  return (dispatch) => {
    if (!skipSpinner) dispatch(fetchingNotifications())
    axios({
      url: `${getServerURL()}notifications/`,
      method: "GET",
      headers:{
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      params: {
        user: userId,
        page: page
      }
    })
    .then(response => {
      const { read, unread, count, results, results_per_page } = response.data
      dispatch(setNotifications({
        read_count: read,
        unread_count: unread,
        total_count: count,
        resultsPerPage: results_per_page,
        data: results
      }))
    })
    .catch(error => {
      const message = "There was an error fetching your notifications"
      handleErrorFetchingData(error, message)
    })
  }
}

export const readNotification = (notification, user) => {
  return dispatch => {
    axios({
      url: notification.url,
      method: "PATCH",
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: { user },
      data: { is_read: true }
    })
    .then(response => {
      // UPDATES THE NUMBER OF READ NOTIFICATIONS IN THE REDUCER
      const updatedNotification = {...notification, is_read: true}
      dispatch(updateReadCount(updatedNotification))
    })
    .catch(error => {
      const message = "There was an error marking your notification as read"
      handleErrorFetchingData(error, message)
    })
  }
}

export const pinNotification = (notification, user) => {
  return dispatch => {
    axios({
      url: notification.url,
      method: "PATCH",
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: { user },
      data: { is_pinned: true }
    })
    .then(response => {
      dispatch(pinnedNotification(notification.url))
    })
    .catch(error => {
      const message = "There was an error pinning your notification"
      handleErrorFetchingData(error, message)
    })
  }
}

export const unpinNotification = (notification, user) => {
  return dispatch => {
    axios({
      url: notification.url,
      method: "PATCH",
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: { user },
      data: { is_pinned: false }
    })
    .then(response => {
      dispatch(unpinnedNotification(notification.url))
    })
    .catch(error => {
      const message = "There was an error un-pinning your notification"
      handleErrorFetchingData(error, message)
    })
  }
}

export const unreadNotification = (notification, user) => {
  return dispatch => {
    axios({
      url: notification.url,
      method: "PATCH",
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: { user },
      data: { is_read: false }
    })
    .then(response => {
      // UPDATES THE NUMBER OF READ NOTIFICATIONS IN THE REDUCER
      const updatedNotification = {...notification, is_read: false}
      dispatch(updateReadCount(updatedNotification))
    })
    .catch(error => {
      const message = "There was an error setting your notification to unread"
      handleErrorFetchingData(error, message)
    })
  }
}

export const readAllNotifications = (user) => {
  return (dispatch) => {
    axios({
      url: `${getServerURL()}read-all-notifications/`,
      method: "GET",
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      params: { user },
    })
    .then(response => {
      dispatch(readingAllNotifications())
    })
    .catch(error => {
      const message = "There was an error marking your notifications as read"
      handleErrorFetchingData(error, message)
    })
  }
}

export const deleteAllNotifications = (user, notifications) => {
  return (dispatch) => {
    dispatch(fetchingNotifications())
    axios({
      url: `${getServerURL()}delete-all-notifications/`,
      method: "GET",
      headers:{
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      params: { user },
    })
    .then(response => {
      dispatch(deletingAllNotifications())
    })
    .catch(error => {
      dispatch(setNotifications(notifications))
      const message = "There was an error deleting your notifications"
      handleErrorFetchingData(error, message)
    })
  }
}

export const deleteNotification = (url, page, user) => {
  return (dispatch) => {
    axios({
      url: url,
      method: "DELETE",
      headers:{
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      params: { user },
    })
    .then(response => {
      dispatch(deletedNotification(url))
      dispatch(getNotifications(user, page, true))
    })
    .catch(error => {
      const message = "There was an error deleting your notification"
      handleErrorFetchingData(error, message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/notifications/reducers/manageNotifications.js